import React, { useState, Fragment } from 'react';

import Image from 'next/image';
import { Row, Col } from '../../designSystem/Container';
import Text from '../../designSystem/Text';
import Alert from '../../designSystem/Alert';
import Chip from '../../designSystem/Chip';

import BmiCoverage from './BmiCoverage';
import CoverageTable from '../CoverageTable';

import styles from './AvailablePlanCoverage.module.scss';

import {
  internationalCoverageText,
  coveragesTabs,
  healthCoverageText,
} from '../../utils/generalTexts';

import { CoverageDetails } from '../../types/availablePlans';
import Prexistances from '@/components/AvailablePlanCoverage/Prexistances';
import DeceaseSection from '../DeceaseSection';

type AvailablePlanCoverageProps = {
  details: CoverageDetails;
  showBmiEnforcement: boolean;
  prexistances: boolean;
  coveragePlanSelected: string;
  brandingCode?: string;
};

function AvailablePlanCoverage({
  details,
  showBmiEnforcement,
  prexistances,
  coveragePlanSelected,
  brandingCode,
}: AvailablePlanCoverageProps) {
  const [categorySelected, setCategorySelected] = useState(coveragesTabs.coverages);

  const tabs = Object.entries(coveragesTabs)
    .filter(([key, value]) => {
      return !(key === 'prexistances' && !prexistances);
    })
    .map(([key, value]) => value);

  const handleCategoryChange = (category: string) => {
    setCategorySelected(category);
  };

  return (
    <Fragment>
      <div className={styles.coverage_container}>
        <Row justify="center">
          <Col sm={12} md={10} lg={7}>
            <Text text={details.title} customClass={styles.coverage_title} />
          </Col>
        </Row>
        <Row justify="center">
          <Col sm={10} md={9} lg={7}>
            <Text text={details.description} customClass={styles.coverage_description} />
          </Col>
        </Row>
        {coveragePlanSelected === 'decease' ? (
          <DeceaseSection details={details} />
        ) : (
          <>
            {coveragePlanSelected === 'health' && (
              <Row justify="center">
                <div className={styles.banner_container}>
                  <Row className={styles.container}>
                    <Col sm={10} md={2} lg={2} className={styles.cat_image_col}>
                      <Image
                        src={healthCoverageText.img(brandingCode).url}
                        alt="gato bice vida celebrando"
                        width={healthCoverageText.img(brandingCode).width}
                        height={healthCoverageText.img(brandingCode).height}
                        className={styles.cat_image}
                      />
                    </Col>
                    <Col md={9} lg={10} className={styles.texts_col}>
                      <Row className={styles.texts_row}>
                        <Col className={styles.title}>{healthCoverageText.title(brandingCode)}</Col>
                        <Col className={styles.description}>
                          {healthCoverageText.description(brandingCode)}
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </div>
              </Row>
            )}
            {!!details.categories.length && (
              <Row justify="center">
                <Col sm={12} md={10} lg={7} className={styles.plans_details_details_col}>
                  {showBmiEnforcement ? (
                    <Chip
                      categories={Object.values(tabs)}
                      categorySelected={categorySelected}
                      setCategorySelected={handleCategoryChange}
                      customClass={styles.chip_container}
                    />
                  ) : (
                    <Text customClass={styles.coverages_tab_text} text={coveragesTabs.coverages} />
                  )}

                  {categorySelected === coveragesTabs.coverages && (
                    <Fragment>
                      <div className={styles.coverage_table_container}>
                        <CoverageTable categories={details.categories} />
                      </div>
                      <div className={styles.alert_container}>
                        {brandingCode !== 'gehma' && (
                          <Alert
                            title={internationalCoverageText.title}
                            text={internationalCoverageText.text}
                            customClass={styles.coverage_alert}
                          />
                        )}
                      </div>
                    </Fragment>
                  )}
                  {categorySelected === coveragesTabs.enforcement && <BmiCoverage />}
                  {categorySelected === coveragesTabs.prexistances && <Prexistances />}
                </Col>
              </Row>
            )}
          </>
        )}
      </div>
    </Fragment>
  );
}

export default AvailablePlanCoverage;
